import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { interpolateRgb } from "d3-interpolate";
import { color } from "d3-color";
import moment from "moment";
import { useSelector } from "react-redux";
import LiquidFillGauge from "react-liquid-gauge";
import { useNavigate } from "react-router-dom"
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Helmet } from 'react-helmet';
import CommonAlert, { GetuserDatavalue } from "../../../Commonalert/commonalert";
import { Tooltip } from "@mui/material";
import Table from '@mui/material/Table';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { Link } from "react-router-dom";
import LinkIcon from '@mui/icons-material/Link';
import DomainAuthoritysvg from "../Asset/esocardicon/BaclinkResearch/DomainAuthority.svg"
import TotalBacklinkssvg from "../Asset/esocardicon/BaclinkResearch/TotalBacklinks.svg"
import TotalFollowlinkssvg from "../Asset/esocardicon/BaclinkResearch/TotalFollowlinks.svg"
import TotalReferringdomainssvg from "../Asset/esocardicon/BaclinkResearch/TotalReferringdomains.svg"
import DatagridComp from "../DatagridComp";
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import Loader from "../CommonLoader";
import { Container } from '@mui/material';


export default function BacklinksResearch(props) {

  const [cardData, setCardData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ErrorMsg, SetErrorMsg] = useState("");
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [autoheightval, SetAutoheightval] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const navigate = useNavigate();
  const [AnalyzeUrl, SetAnalyzeUrl] = useState('')
  const [DomainAuthority, SetDomainAuthority] = useState(0)
  const [TotalBacklink, SetTotalBacklink] = useState(0)
  const [TotalReferringDomain, SetTotalReferringDomain] = useState(0)
  const [TotalFollowLink, SetTotalFollowLink] = useState(0)
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const Item = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  const columns = [

    {
      field: "referring_page",
      headerName: "Title/Referring Page",
      minWidth: 300,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "Referring page's title/Referring page's URL.",
      renderCell: (cardData) => {
        let baseUrl = cardData?.row?.referring_page.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData?.row?.referring_page.split("/").slice(3).join("/");

        return (
          <div classname="link-dt-left"><span style={{ color: "hsl(38.3deg 100% 56.08%)" }}>{cardData?.row?.title}</span>
            <br />
            <Tooltip title={cardData.row.referring_page}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.referring_page} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </div>
        );
      },
    },

    // {
    //   field: "domain_authority",
    //   headerName: "DA",
    //   minWidth: 150,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: true,
    //   description: "Domain InLink Rank of the target's root domain.",
    // },
    {
      field: "domain_authority",
      headerName: "DA",
      minWidth: 150,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "Domain InLink Rank of the target's root domain.",
      renderCell: (cardData) => {
        var sr = cardData.row.domain_authority;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: '#0b2033',
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
              fontFamily: "Poppins, sans-serif",
            }}
          />
        );
      },
    },
    // {
    //   field: "page_authority",
    //   headerName: "PA",
    //   minWidth: 150,
    //   flex: 1,
    //   headerAlign: 'center',
    //   align: 'center',
    //   sortable: true,
    //   description: "InLink rank of the target URL.",
    // },
    {
      field: "page_authority",
      headerName: "PA",
      minWidth: 150,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      description: "InLink rank of the target URL.",
      renderCell: (cardData) => {
        var sr = cardData.row.page_authority;
        var s = sr
        return (
          <LiquidFillGauge
            style={{ margin: "0 auto" }}
            width={44}
            height={44}
            value={s}
            percent=""
            textSize={1}
            textOffsetX={0}
            textOffsetY={0}
            riseAnimation
            waveAnimation
            waveFrequency={2}
            waveAmplitude={1}
            gradient
            gradientStops={gradientStops}
            circleStyle={{
              fill: "#0b2033",
            }}
            waveStyle={{
              fill: fillColor,
            }}
            textStyle={{
              fill: color("#0b2033").toString(),
            }}
            waveTextStyle={{
              fill: color("#0b2033").toString(),
            }}
          />
        );
      },
    },
    {
      field: "anchor",
      headerName: "Anchor/Target Page",
      minWidth: 400,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      description: "Link anchor text for text links/Destination page's URL..",
      renderCell: (cardData) => {
        let baseUrl = cardData?.row?.target_page.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData?.row?.target_page.split("/").slice(3).join("/");
        let baseUrl1 = cardData?.row?.anchor.split("/").slice(0, 3).join("/") + "/";
        let remaining1 = cardData?.row?.anchor.split("/").slice(3).join("/");
        return (
          <div classname="link-dt-left"><span style={{ color: "hsl(38.3deg 100% 56.08%)" }}>
            {baseUrl1}<br />
            {remaining1}
            {/* {cardData?.row?.anchor} */}
            {/* <span className="" style={{ color: "#044792", display: 'flex', wordWrap: "break-word", wordBreak: "break-word" }} >{baseUrl1}</span>
            <span className="" style={{ color: "#044792", display: 'flex', wordWrap: "break-word", wordBreak: "break-word" }} >{remaining1}</span> */}
          </span>
            <br />
            <Tooltip title={cardData.row.target_page}>
              <div className="prefered_url_external02">
                <a target="_blank" href={cardData?.row?.target_page} style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }} >{remaining}</span>
                </a>
              </div>
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "link_type",
      headerName: "Link Type",
      minWidth: 130,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "Type of backlink.",
    },
    {
      field: "nofollow",
      headerName: "Follow/No Follow",
      minWidth: 100,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "Number of backlinks marked as nofollow and number of backlinks not marked as nofollow.",
    },
    {
      field: "first_seen",
      headerName: "First Seen",
      minWidth: 120,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "The date when the backlink was added to the index or the date when our crawlers last visited the referring page.",
    },
    {
      field: "last_visited",
      headerName: "Last Visited",
      minWidth: 120,
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: true,
      description: "The date when the backlink was added to the index or the date when our crawlers last visited the referring page.",
    },
  ];

  const rows = cardData ?? [];
  const LoadData = async (tableid = '') => {
    var JobId = '';
    if (props.RankJob) {
      if (props.RankJob.value) {
        JobId = props.RankJob.value
      }
    }
    setLoading(true)
    setTableLoading(true);
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}backlinks/backlinks_research/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${JobId}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });


      if (datavalue?.data) {
        if (datavalue?.data?.job_details) {

          props.setjobDate(moment(datavalue.data.job_details.job_date).format("MMMM DD,YYYY HH:mm"));
        }
      }

      if (datavalue.data) {

        if (datavalue.data.research_data) {
          SetDomainAuthority(datavalue.data.research_data.domain_authority)
          SetTotalBacklink(datavalue.data.research_data.total_backlinks_count)
          SetTotalFollowLink(datavalue.data.research_data.total_follow_links)
          SetTotalReferringDomain(datavalue.data.research_data.total_ref_domains)
          SetResearchType(datavalue.data.research_data.research_mode)
          SetResearchUrl(datavalue.data.research_data.research_url)
          SetRefilldate(datavalue.data.research_data.next_refill_date)
          SetTotalLimit(datavalue.data.research_data.total_research_limit)
          SetAvailableLimit(datavalue.data.research_data.available_research_count)
        }
        if (datavalue.data.research_table) {
          if (datavalue.data.research_table.data) {
            var TableArray = [];
            TableArray = datavalue.data.research_table.data;

            if (TableArray && TableArray.length > 0) {
              const newData = TableArray.map((obj, index) => {
                return { ...obj, sid: index + 1 };
              });
              setCardData(newData);
              SetAutoheightval(false)
            }
            else {
              setCardData("");
              SetAutoheightval(true)
            }
          }
        }
      }
    } catch (err) {
      console.log(err)
    }
    setTableLoading(false);
    setLoading(false);
  }
  const AnalyzeReport = async () => {
    setLoading(true);
    setTableLoading(true);
    SetErrorMsg('')
    if (AnalyzeUrl === '') {
      SetErrorMsg('Please enter a URL')
      setLoading(false)
      return false
    }
    SetDomainAuthority('0')
    SetTotalBacklink('')
    SetTotalFollowLink('')
    SetTotalReferringDomain('')
    SetResearchType('')
    SetResearchUrl('')
    SetRefilldate('')
    SetTotalLimit('')
    SetAvailableLimit('')
    setCardData([])
    props.SetBacklinkurl(AnalyzeUrl)
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}backlinks/backlinks_research/?user_domain_id=${esodata.domaindata.value.header_selected}&request_url=${AnalyzeUrl}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data) {

        if (datavalue?.data?.research_graph) {
          SetDomainAuthority(datavalue.data.research_graph.domain_authority)
          SetTotalBacklink(datavalue.data.research_graph.total_backlinks_count)
          SetTotalFollowLink(datavalue.data.research_graph.total_follow_links)
          SetTotalReferringDomain(datavalue.data.research_graph.total_ref_domains)
          SetResearchType(datavalue.data.research_graph.research_mode)
          SetResearchUrl(datavalue.data.research_graph.research_url)
          SetRefilldate(datavalue.data.research_graph.next_refill_date)
          SetTotalLimit(datavalue.data.research_graph.total_research_limit)
          SetAvailableLimit(datavalue.data.research_graph.available_research_count)
        }

        if (datavalue.data.research_table) {
          const FDataval = datavalue.data.research_table.table
          if (FDataval && FDataval.length > 0) {
            const newData = FDataval.map((obj, index) => {
              return { ...obj, sid: index + 1 };
            });
            setCardData(newData);
            SetAutoheightval(false)
          }
          else {
            setCardData("");
            SetAutoheightval(true)

          }
        }
      }

      if (datavalue.data.error) {
        SetErrorMsg(datavalue.data.error)
      }
    } catch (err) {
      console.log('errr', err)
    }
    setTableLoading(false);
    setLoading(false);
  }
  useEffect(() => {
    GetuserDatavalue(setOpenCommonAlerts, ApiToken, navigate);
    LoadData()
  }, []);

  useEffect(() => {
    if (props.FilterButtonTriggered === true) {
      LoadData()
      props.SetFilterButtonTriggered(false)
      props.closeModal()
    }

  }, [props])

  const cardDatas = [
    { title: "Domain Authority", value: DomainAuthority, iconSrc: DomainAuthoritysvg, altText: "Domain Authority", iconColor: 1, bgColor: 1 },
    { title: "Total Backlinks", value: TotalBacklink, iconSrc: TotalBacklinkssvg, altText: "Total Backlinks", iconColor: 2, bgColor: 2 },
    { title: "Total Referring domains", value: TotalReferringDomain, iconSrc: TotalReferringdomainssvg, altText: "Total Referring domains", iconColor: 3, bgColor: 3 },
    { title: "Total Follow links", value: TotalFollowLink, iconSrc: TotalFollowlinkssvg, altText: "Total Follow links", iconColor: 4, bgColor: 4 },
  ];

  const [ResearchUrl, SetResearchUrl] = useState('')
  const [Refilldate, SetRefilldate] = useState('')
  const [TotalLimit, SetTotalLimit] = useState('')
  const [AvailableLimit, SetAvailableLimit] = useState('')
  const [ResearchType, SetResearchType] = useState('')

  var startColor = "#6495ed";
  var endColor = "#dc143c";
  const interpolate = interpolateRgb(startColor, endColor);
  const fillColor = "rgb(255,174,31)";
  const textfillColor = "rgb(255,255,255)";
  const gradientStops = [
    {
      key: "0%",
      stopColor: color(fillColor).darker(0.5).toString(),
      stopOpacity: 1,
      offset: "0%",
    },
    {
      key: "50%",
      stopColor: fillColor,
      stopOpacity: 0.75,
      offset: "50%",
    },
    {
      key: "100%",
      stopColor: color(fillColor).brighter(0.5).toString(),
      stopOpacity: 0.5,
      offset: "100%",
    },
  ];
  const handleModelPopUp = () => {
    props.openModal();
  }

  const handleDownlodingCSV = () => {
    props.csvdown();
  }

  const handleDownlodingPDF = () => {
    props.pdfdown();
  }


  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Backlinks Research</title>
      </Helmet>
      {loading === true ? <Loader /> : null}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {/* <Grid container spacing={2} my={2}>
        <Grid item xs={12}>
          <Item className="table-bg-color">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <div className="table-container">
                  <Table aria-label="basic table" className="custom-table">
                    <tbody>
                      <tr>
                        <td className="bold-cell">For {ResearchType}:</td>
                        <td className="table-cell"><Link to="{ResearchUrl}" target="_blank">
                          {ResearchUrl}</Link>
                        </td>

                      </tr>
                      <tr>
                        <td className="bold-cell">Next Refill Date:</td>
                        <td className="table-cell">{Refilldate}</td>

                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Grid>

              <Grid item xs={12} md={6}>
                <div className="table-container">
                  <Table aria-label="basic table" className="custom-table">
                    <tbody>
                      <tr>
                        <td className="bold-cell">Total Search Limit:</td>
                        <td className="table-cell">{TotalLimit}</td>
                      </tr>
                      <tr>
                        <td className="bold-cell">Available Research Count:</td>
                        <td className="table-cell">{AvailableLimit}</td>

                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Grid>

            </Grid>
          </Item>
        </Grid>
      </Grid> */}


      <Container maxWidth={false} className="graph-container">
        <Box className="graph-box">
          <Grid container className="graph-grid">
            <Grid item xs={12} md={6}>
              <div className="table-container">
                <Table aria-label="basic table" className="custom-table">
                  <tbody>
                    <tr>
                      <td className="bold-cell">For {ResearchType}:</td>
                      <td className="table-cell"><Link to="{ResearchUrl}" target="_blank">
                        {ResearchUrl}</Link>
                      </td>
                    </tr>
                    <tr>
                      <td className="bold-cell">Next Refill Date:</td>
                      <td className="table-cell">{Refilldate}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="table-container">
                <Table aria-label="basic table" className="custom-table">
                  <tbody>
                    <tr>
                      <td className="bold-cell">Total Search Limit:</td>
                      <td className="table-cell">{TotalLimit}</td>
                    </tr>
                    <tr>
                      <td className="bold-cell">Available Research Count:</td>
                      <td className="table-cell">{AvailableLimit}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={12}>
              <div className="common-card-container">
                {cardDatas.map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={index}>
                    <Commoncard item={item} />
                  </Grid>
                ))}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container> */}

      <Container maxWidth={false} className="dashboard-card-container">
        <Box >
          <Grid container>
            <Grid container spacing={3} justifyContent="center">
              {cardDatas.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={item.id}>
                  <Commoncard
                    item={item}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-card-container">
        <Box className="dashboard-box-card">
          <Grid container className="dashboard-card-grid">
            <Grid item xs={12} md={6}>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="drop_down_button">
                <div className="input_col">
                  <input type="text" style={{ height: "45px" }} onChange={(e) => { SetAnalyzeUrl(e.target.value) }} placeholder="Enter domain-related URL to check" />
                  <div className="error_plagarism_report ">
                    {
                      ErrorMsg
                    }
                  </div>
                </div>
                <div className=""><button class="btn_dashboard" onClick={AnalyzeReport}>Analyze</button></div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp className="datagrid_custom_scroll"
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  columnFreezeWidth={[0, 200]}
                  tableLoading={tableLoading}
                  handleModelPopUp={handleModelPopUp}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  DownloadShowFile={true}
                  customFilter={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>



      {/* <DatagridComp
        columns={columns}
        rows={rows}
        autoheightval={autoheightval}
        datagridval={2}
        columnFreezeWidth={[0, 300]}
        tableLoading={tableLoading}
      /> */}
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }

    </>
  );
}
